import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home01, Folder, Code01, Briefcase01 } from '@untitledui/icons';
import profilePic from '../images/new-headshot.jpg';
import portfolio from '../portfolio.json';
import resume from '../resume.json';

export const LeftSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { section_name } = resume.basic_info;
  const { name } = portfolio.basic_info;

  const navItems = [
    { label: section_name.home, path: '/', Icon: Home01 },
    { label: section_name.projects, path: '/projects', Icon: Folder },
    { label: section_name.skills, path: '/skills', Icon: Code01 },
    { label: section_name.experience, path: '/experience', Icon: Briefcase01 },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleNavigation = (path) => {
    navigate(path);
    // Scroll to top when Home is clicked
    if (path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // For other routes, the Navigation component will handle scrolling to content
  };

  return (
    <Box sx={leftSidebarStyles}>
      <Box sx={logoContainerStyles}>
        <i className="fa-solid fa-bolt" style={{ fontSize: '24px', color: '#1d9bf0' }}></i>
      </Box>
      <Box sx={navItemsContainerStyles}>
        {navItems.map((item) => {
          const IconComponent = item.Icon;
          return (
            <Box
              key={item.path}
              sx={{
                ...navItemStyles,
                ...(isActive(item.path) ? activeNavItemStyles : {}),
              }}
              onClick={() => handleNavigation(item.path)}
            >
              <IconComponent sx={iconStyles} />
              <Box component="span" sx={navItemLabelStyles}>{item.label}</Box>
            </Box>
          );
        })}
      </Box>
      <Button sx={tweetButtonStyles} variant="contained" fullWidth>
        Portfolio
      </Button>
      <Box sx={profileSectionStyles}>
        <Box sx={profileMiniStyles}>
          <Box component="img" 
            src={profilePic} 
            alt="profile"
            sx={profileMiniImgStyles}
          />
          <Box sx={profileMiniInfoStyles}>
            <Box component="span" sx={profileMiniNameStyles}>{name}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const leftSidebarStyles = {
  position: 'fixed',
  left: 0,
  top: 0,
  height: '100vh',
  width: '240px',
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid #e1e8ed',
  backgroundColor: '#fff',
  '@media (max-width: 768px)': {
    display: 'none',
  },
};

const logoContainerStyles = {
  padding: '12px',
  marginBottom: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

const navItemsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
};

const navItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '10px',
  borderRadius: '9999px',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f7f9fa',
  },
};

const iconStyles = {
  width: '20px',
  height: '20px',
  color: '#0f1419',
  flexShrink: 0,
};

const activeNavItemStyles = {
  fontWeight: 700,
  '& svg': {
    color: '#0f1419',
  },
};

const navItemLabelStyles = {
  fontSize: '19px',
  color: '#0f1419',
  fontWeight: 400,
  '@media (max-width: 1300px)': {
    fontSize: '17px',
  },
};

const tweetButtonStyles = {
  marginTop: '8px',
  padding: '12px 16px',
  borderRadius: '9999px',
  fontSize: '15px',
  fontWeight: 700,
  backgroundColor: '#1d9bf0',
  textTransform: 'none',
  minHeight: '48px',
  '&:hover': {
    backgroundColor: '#1a8cd8',
  },
};

const profileSectionStyles = {
  marginTop: 'auto',
  padding: '12px',
  borderRadius: '9999px',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f7f9fa',
  },
};

const profileMiniStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

const profileMiniImgStyles = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  objectFit: 'cover',
};

const profileMiniInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
};

const profileMiniNameStyles = {
  fontSize: '15px',
  fontWeight: 700,
  color: '#0f1419',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

